module.exports = __webpack_public_path__ + "static/media/v3.65a7561a.mp4";